import { Injectable } from "@angular/core";
import { UserService } from "../user/user.service";
import { combineLatest, map, mergeMap, Observable, shareReplay, take } from "rxjs";
import { GroupMembershipService } from "../group-membership/group-membership.service";

@Injectable({
    providedIn: "root",
})
export class AdminConsoleService {
    private readonly DEV_ADMIN_CONSOLE_GROUP_ID = 'e03ef1df-9e0d-4b16-8859-dadeffd43b7e';

    private isAdmin$: Observable<boolean>;
    private isOwner$: Observable<boolean>;

    constructor(
        private userService: UserService,
        private groupMembershipService: GroupMembershipService
    ) {
        this.isAdmin$ = this.getIsAdmin$();
        this.isOwner$ = this.getIsOwner$();
    };

    getIsAdmin$(): Observable<boolean> {
        return this.userService.getUserTeams()
            .pipe(
                take(1),
                map((teams) => {
                    if (teams.length === 0) {
                        return false;
                    }

                    return teams.some((team) => {
                        return team.id === this.DEV_ADMIN_CONSOLE_GROUP_ID;
                    });
                }),
                shareReplay(1),
            );
    };

    getIsOwner$(): Observable<boolean> {
        return this.userService.getUser()
            .pipe(
                take(1),
                mergeMap((user) => this.groupMembershipService.getGroupOwners(this.DEV_ADMIN_CONSOLE_GROUP_ID)
                    .pipe(
                        map((response) => response.value as any[]),
                        map((owners) => {
                            if (!owners || owners.length === 0) {
                                return false;
                            }
                            return owners.some((owner: any) => owner.id === user.id);
                        })
                    )
                ),
                shareReplay(1)
            );
    };

    getAdminStatus(): Observable<{ isAdmin: boolean, isOwner: boolean }> {
        return combineLatest([this.isAdmin$, this.isOwner$]).pipe(
            map(([isAdmin, isOwner]) => ({ isAdmin, isOwner }))
        );
    };
}
